import { render, staticRenderFns } from "./BuyersSelectedActions.vue?vue&type=template&id=38633a7f&scoped=true&"
import script from "./BuyersSelectedActions.vue?vue&type=script&lang=ts&"
export * from "./BuyersSelectedActions.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersSelectedActions.vue?vue&type=style&index=0&id=38633a7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38633a7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTooltip})
